/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import LottieView from "lottie-react";

import { skaleModalTextGray, skaleModalErrorRed } from "config/UpduoColors";
import { styles, Text } from "UpduoLibrary";
import xmarkAnimation from "assets/xmark_lottie.json";
import checkmarkAnimation from "assets/checkmark_lottie.json";

export default function SessionCompleteModalBody({
  skillName,
  lastSessionWasCancelled,
}: {
  skillName: string;
  lastSessionWasCancelled: boolean;
}) {
  const title = lastSessionWasCancelled
    ? "Session Incomplete"
    : "Session Complete!";

  const message = lastSessionWasCancelled ? (
    "Your session was too short and won't count towards quota completion"
  ) : (
    <>
      {"You have completed\n"}
      <Text style={{ fontWeight: "bold" }}>{`“${skillName}.”`}</Text>
      {" Good\u00a0job!"}
    </>
  );

  const textColor = lastSessionWasCancelled
    ? skaleModalErrorRed
    : skaleModalTextGray;

  return (
    <>
      <Text isHeading={true} style={styles.modalTitleText}>
        {title}
      </Text>
      <LottieView
        style={{ width: 150 }}
        animationData={
          lastSessionWasCancelled ? xmarkAnimation : checkmarkAnimation
        }
        autoPlay={true}
        loop={false}
      />
      <Text
        style={{
          color: textColor,
          textAlign: "center",
          marginBottom: 24,
          fontSize: 16,
          flexShrink: 1,
        }}
      >
        {message}
      </Text>
    </>
  );
}
